import { Layout } from "antd"

type Props = {
  children: React.ReactNode
}

export const ContentWrapper: React.FC<Props> = ({ children }) => {
  return (
    <Layout.Content style={{ width: "95%", margin: "0 auto" }}>
      {children}
    </Layout.Content>
  )
}
